/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Clear_Network_AssociationInputs */



/**
* | output |
* | --- |
* | "Remove network association" |
*
* @param {Air_Handler_Unit_Clear_Network_AssociationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_clear_network_association = /** @type {((inputs?: Air_Handler_Unit_Clear_Network_AssociationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Clear_Network_AssociationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Remove network association")
	return /** @type {LocalizedString} */ ("Supprimer l'association au ")
});